<template>
  <div>
      <v-container>
          <CRUDCriteria
              :showReset="false"
              :showSearch="false"
          >
          <template v-slot:criteriaRows>
          <v-row>
            <v-col cols="2">
              <FySelect
                v-model="fiscalYear"
                :fyRange="fiscalYearRange"
                id="check-TaxPayment-Balcriteria-FY-select"
                class="checkTaxPaymentBalCriteriaFYSelect"
                @input="onChangeFy"
              />
            </v-col>
            <v-col cols="2">
              <ClarionDateControl
                v-model="fromDate"
                :isRequired="false"
                :isIsoDate="true"
                :isToggle="false"
                :label="`From Date`"
              />
            </v-col>
            <v-col cols="2">
              <ClarionDateControl
                v-model="toDate"
                :isRequired="false"
                :isIsoDate="true"
                :isToggle="false"
                :label="`To Date`"
              />
            </v-col>
            <v-col cols="3">
              <v-select
                v-model="selectedTaxType"
                :items="taxTypeOptions"
                label="Tax Type"
                outlined
                dense
                @change="onChangeTaxType"
              />
            </v-col>
            <v-col cols="3">
              <v-btn color="primary"
              rounded
              @click="gatherInfo"
              >
              Gather Information
              </v-btn>
            </v-col>
          </v-row>
        </template>
          </CRUDCriteria>
          <h2 align="center">{{ reportTitle }}</h2>
    <div align="center">
      <span class="ml-4">
          {{ `From:${fromDate}` }}
      </span>
      <span class="ml-4">
          {{ `To:${toDate}` }}
      </span>
    </div>
    <hr>
    <v-simple-table
      id="glUtilTaxPaymentBalanceToGLReportTable"
      class="gl-util-tax-payment-balance-to-gl-report-table"
      dense
    >
      <template v-slot:default>
        <thead  >
          <tr>
            <th>
              Date
            </th>
            <th class="text-right">
              {{ collectionColumnHeader }}
            </th>
            <th class="text-right">
              Running Total
            </th>
            <th class="text-right">
              GL Balance
            </th>
            <th class="text-right"></th>
          </tr>
        </thead>
        <tbody>
          <template >
          <tr
          v-for="item in loadData"
          :key="item.date"
          :class="getRowClass(item)"
          >
            <td class="text-left">{{ item.date }}</td>
            <td class="text-right">{{ amountFormat(item.taxAmt)}}</td>
            <td class="text-right">{{ amountFormat(item.runningTotal)}}</td>
            <td class="text-right">{{ amountFormat(item.gLBalance)}}</td>
          </tr>
          </template>
        </tbody>
      </template>
    </v-simple-table>
  <hr>
      </v-container>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import ClarionDateControl from '../../common/ClarionDateControl.vue';
import FySelect from '../../common/FySelect.vue';
import CRUDCriteria from '../../common/base/crud/CRUDCriteria.vue';
import { calculateFiscalYears } from '../../../util/shared/tmc-global';
import { amountFormat } from '../../../util/shared/vue-global';

const TAX_TYPES = {
  CURRENT: 'currentTax',
  PRIOR: 'priorTax',
  BACK: 'backTax',
  SPECIAL_ASSESSMENT: 'specialAssessment',
};

const TAX_TYPE_OPTIONS = [
  { text: 'Current Tax', value: TAX_TYPES.CURRENT },
  { text: 'Prior Tax', value: TAX_TYPES.PRIOR },
  { text: 'Back Tax', value: TAX_TYPES.BACK },
  { text: 'Special Assessment', value: TAX_TYPES.SPECIAL_ASSESSMENT },
];

const TAX_TYPE_LABELS = {
  [TAX_TYPES.CURRENT]: 'Current Tax Collection',
  [TAX_TYPES.PRIOR]: 'Prior Tax Collection',
  [TAX_TYPES.BACK]: 'Back Tax Collection',
  [TAX_TYPES.SPECIAL_ASSESSMENT]: 'Special Assessment Collection',
};

const TAX_TYPE_REPORT_TITLES = {
  [TAX_TYPES.CURRENT]: 'CURRENT TAX COLLECTIONS COMPARED TO GL BALANCE',
  [TAX_TYPES.PRIOR]: 'PRIOR TAX COLLECTIONS COMPARED TO GL BALANCE',
  [TAX_TYPES.BACK]: 'BACK TAX COLLECTIONS COMPARED TO GL BALANCE',
  [TAX_TYPES.SPECIAL_ASSESSMENT]: 'SPECIAL ASSESSMENT COLLECTIONS COMPARED TO GL BALANCE',
};

export default {
  name: 'CheckTaxPaymentBalToGL',
  components: {
    CRUDCriteria,
    ClarionDateControl,
    FySelect,
  },
  data: () => ({
    fiscalYear: undefined,
    glBaseCrudKey: 'glDailyTransaction',
    fromDate: '',
    toDate: '',
    loadData: [],
    selectedTaxType: TAX_TYPES.CURRENT,
    taxTypeOptions: TAX_TYPE_OPTIONS,
  }),
  created() {
    this.initialValue();
  },
  computed: {
    ...mapGetters(['todaysDate']),
    ...mapState({
      fiscalYearRange: (state) => {
        const registerdYears = state.glDaily.glDailyTransaction.regYears || {};
        return calculateFiscalYears(registerdYears);
      },
    }),
    collectionColumnHeader() {
      return TAX_TYPE_LABELS[this.selectedTaxType];
    },
    reportTitle() {
      return TAX_TYPE_REPORT_TITLES[this.selectedTaxType];
    },
  },
  methods: {
    ...mapActions('glDaily/glDailyTransaction', ['loadFiscalRegYears']),
    ...mapActions('glDaily/checkTaxPaymentBalanceToGL', ['taxPaymentBalToGLGatherInformation']),
    amountFormat,
    async initialValue() {
      await this.loadFiscalRegYears({ baseCrudKey: this.glBaseCrudKey });
      const regYears = (this.fiscalYearRange || []);
      this.fiscalYear = (regYears[regYears.length - 1] || {}).year;
      this.fromDate = this.todaysDate;
      this.toDate = this.todaysDate;
    },
    onChangeFy(val) {
      this.fiscalYear = val;
    },
    onChangeTaxType(val) {
      this.selectedTaxType = val;
      this.loadData = [];
    },
    getRowClass(item) {
      return item.matchAmtFlag ? 'accent-1' : 'red accent-1';
    },
    async gatherInfo() {
      const criteria = {
        fiscalYear: this.fiscalYear,
        fromDate: this.fromDate,
        toDate: this.toDate,
        taxType: this.selectedTaxType,
      };
      const result = await this.taxPaymentBalToGLGatherInformation({ criteria });
      this.loadData = result;
    },
  },
};
</script>
